import { API } from '../../utils';
import { GW_SERVICES_PREFIXES } from 'constants/gateway';

const { AUTHORIZATION } = GW_SERVICES_PREFIXES;

export const GenerateQrCode = (data: {
  session_id: string;
  messenger: string;
}) => API.gatewayPost(`/${AUTHORIZATION}/auth/qr/generate/`, data);

export const GetQrAuthStage = (sessionId: string) =>
  API.get(`/${AUTHORIZATION}/auth/qr/stage/`, sessionId);
